import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { mediaQueries } from 'plugins/device'
import { Modal as BuiModal, TextHeadline3, Button, TextCallout2, colors } from '@blocket/blocket-ui'

const Modal = styled(BuiModal)`
  @media ${mediaQueries.medium} {
    max-width: 350px;
  }
`

const ContentWrapper = styled.div`
  padding: 24px;
  text-align: center;
`

const Headline = styled(TextHeadline3)`
  margin-bottom: 12px;
`

const ActionButton = styled(Button)`
  margin: 20px auto;
  max-width: 200px;
`

const CloseButton = styled.button`
  border: none;
  color: ${colors.blue600};
  cursor: pointer;
`

const RemoveChannelModal = ({ open, handleRemoveModal, handleRemoveChannel }) => {
  return (
    <Modal
      label="label text describing the modal's purpose for accessibility"
      open={open}
      onClose={handleRemoveModal}
    >
      <ContentWrapper>
        <Headline>Vill du ta bort konversationen? </Headline>
        <TextCallout2>Den här konversationen kommer att tas bort permanent för dig.</TextCallout2>
        <ActionButton type="primary" onClick={handleRemoveChannel}>
          Ta bort
        </ActionButton>
        <CloseButton onClick={handleRemoveModal}>Avbryt</CloseButton>
      </ContentWrapper>
    </Modal>
  )
}

RemoveChannelModal.propTypes = {
  open: PropTypes.bool,
  handleRemoveModal: PropTypes.func,
  handleRemoveChannel: PropTypes.func,
}

export default RemoveChannelModal
